import PropTypes from 'prop-types';

const titleTable = ['id', 'name', 'createdDate'];
export default { titleTable }
